<template>
  <vab-icon
    v-if="false"
    class="fold-unfold"
    :icon="collapse ? 'menu-unfold-line' : 'menu-fold-line'"
    @click="toggleCollapse"
  />
</template>

<script>
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
export default {
  name: 'VabFold',
  setup() {
    const store = useStore()
    const route = useRoute()
    const collapseIsShow = ref(false)
    watch(
      () => route.path,
      async () => {
        const isCollapse = route.meta.collapse
        if (!isCollapse) {
          collapseIsShow.value = true
          console.log('展示')
          await store.dispatch('settings/setCollapseIsShow', true)
        } else {
          collapseIsShow.value = false
          console.log('不展示')
          await store.dispatch('settings/setCollapseIsShow', false)
        }
      }
    )
    return {
      collapseIsShow,
      collapse: computed(() => store.getters['settings/collapse']),
      toggleCollapse: () => store.dispatch('settings/toggleCollapse'),
    }
  },
}
</script>

<style lang="scss" scoped>
.fold-unfold {
  color: $base-color-grey;
  cursor: pointer;
}
</style>
